<template>
  <div class="hidden lg:block mx-auto grow">
    <ul
      id="navbar-navlist"
      class="grow flex flex-col lg:flex-row lg:items-center lg:justify-center mt-4 lg:mt-0"
    >
      <slot></slot>
    </ul>
  </div>
</template>
